import api from './api'

export interface UserTeamStats {
  userId: number
  username: string
  displayName: string
  discordId: string | null
  discordAvatar: string | null
  groupPlaySlot: string | null
  gamesPlayed: number
  wins: number
  losses: number
  ties: number
  winPercentage: number
  totalPassingYards: number
  totalRushingYards: number
  totalReceivingYards: number
  passingAttempts: number
  passingCompletions: number
  passingCompletionPercentage: number
  passerRating: number
  passingTouchdowns: number
  passingInterceptions: number
  rushingAttempts: number
  rushingTouchdowns: number
  rushingYardsPerCarry: number
  totalPassingYardsAllowed: number
  totalRushingYardsAllowed: number
  fumblesLost: number
  opponentFumblesLost: number
  interceptionsMade: number
  fourthDownStops: number
  fourthDownStopsAllowed: number
  fieldGoalBlocks: number
  fieldGoalBlocksAllowed: number
  injuries: number
  opponentInjuries: number
  tacklesMade: number
  tacklesTaken: number
  netFumbles: number
  netInterceptions: number
  netFourthDownStops: number
  netFieldGoalBlocks: number
  netInjuries: number
  netInjuryLuckScore: number
  netTakeaways: number
  netTackles: number
  netLuckScore: number
  totalTimeOfPossessionSeconds: number
  opponentTimeOfPossessionSeconds: number
  averageTimeOfPossessionSeconds: number
  opponentAverageTimeOfPossessionSeconds: number
  passingYardsPerGame: number
  rushingYardsPerGame: number
  receivingYardsPerGame: number
  passingYardsAllowedPerGame: number
  rushingYardsAllowedPerGame: number
}

export async function fetchUserTeamStats(): Promise<UserTeamStats[]> {
  const response = await api.get<UserTeamStats[]>('/stats/users')
  return response.data
}




